export enum PcsActivityTypeEnum {
    CollegeSocietyMeeting = "CSM",
    Course = "CRE",
    ELearningCourse = "ELC",
    Other = "OTR",
    ScientificMeeting = "SCM",
    Seminar = "SMR",
    SpecialtyRelevantCourse = "SRC",
    Webinar = "WBR",
    Workshop = "WSP"
}